module.exports = __webpack_public_path__ + "static/img/non-banking.44119011.svg";